'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Check from './icons/Check.js';
import Copy from './icons/Copy.js';
import { childrenToString } from '../utils/utils.js';
const CodeBlockWithCopy = ({ children }) => {
    const [isCopied, setIsCopied] = useState(false);
    const copyToClipboard = () => {
        const codeContent = childrenToString(children);
        if (!codeContent)
            return;
        navigator.clipboard.writeText(codeContent).then(() => {
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000); // "Copied!" message for 2 seconds
        });
    };
    return (_jsxs("div", { className: "pre-container", children: [_jsx("button", { type: "button", onClick: copyToClipboard, children: isCopied ? _jsx(Check, {}) : _jsx(Copy, {}) }), _jsx("pre", { children: children })] }));
};
export default CodeBlockWithCopy;
